// We are relying on jQuery being called in a separate script file.
var $ = window.jQuery;


/* ==========================================================================
   THEME ES6 COMPONENTS -- WOOCOMMERCE
   ========================================================================== */
import quantity from './quantity-controls';
import SingleProduct from './single-product';
import Shop from './shop';
import Checkout from './Checkout';
import MiniCart from './mini-cart';
// import './add-to-cart-variation.js';
// we count on matchHeight being loaded in main.js https://github.com/liabru/jquery-match-height

export default function() {


    // init quantity controls with + / - next to them.
    quantity();

    // All js for ajax-mini cart
    new MiniCart();

    // al the JS for single product page
    new SingleProduct();

    // all the JS for checkout page.
    new Checkout();

    // all the JS for Shop page.
    new Shop();


    function matchHeightProducts() {
        // if matchHeight is enabled, make all product grids the same height.
        if ($.fn.matchHeight) {
            $('.products .woocommerce-LoopProduct-link').matchHeight();
            $('.products .product:not(product-category)').matchHeight();
        } else {
            console.log("Emote: Install the matchheight plugin if you want equal height products in the grid.");
        }
    }

    matchHeightProducts();

    $(document.body).on('shop_html_did_update', matchHeightProducts);



}